<div class="flex-col height100p">
    @if (def?.useSearchBar) {
        <sm-toolbar>
            <input pInputText [(ngModel)]="input">
            <p-button icon="fas fa-search" [label]="def.searchBarLabel" (onClick)="searchDocuments()"></p-button>
        </sm-toolbar>
    }
    @if (def != null) {
        <sm-toolbar>
            <ng-content></ng-content>
            <button *ngIf="def.canUpload" pButton icon="fas fa-cloud-upload-alt" [label]="app.t('documents.uploadDocument')" (click)="newDocument($event)"></button>
            <button *ngIf="def.hasDocuments && table?.rows?.length > 0" pButton icon="fas fa-file-download" [label]="app.t('documents.downloadAll')" (click)="downloadAll()"></button>
            <p-splitButton *ngIf="table != null" [label]="app.t('documents.exportAsCsv')" icon="fas fa-file-download" [model]="exportMenuItems" (onClick)="exportCsv()"></p-splitButton>
            <input pInputText class="width400" type="text" [placeholder]="app.t('documents.search')" [(ngModel)]="fullTextSearchTerm" (ngModelChange)="updateFilter()">
            <ng-container *ngIf="def.useSeenMarker">
                <span class="toolbar-divider"></span>
                <p-checkbox *ngIf="def.useSeenMarker" class="mr-3" [label]="app.t('documents.useSeenMarker')" [(ngModel)]="displaySeen" [binary]="true" (ngModelChange)="updateFilter()"></p-checkbox>
                <button pButton icon="fas fa-eye" [label]="app.t('documents.markAllAsSeen')" (click)="markAllAsSeen()"></button>
            </ng-container>
            <ng-container *ngIf="searchFields.length > 0">
                <span class="toolbar-divider"></span>
                <span *ngFor="let field of searchFields" class="width200">
                    <span class="mr-2">{{field.caption}}</span>
                    <app-sm-form-field-internal [field]="field" fluentWidth="200px">
                    </app-sm-form-field-internal>
                </span>
                <button pButton icon="fas fa-filter" [label]="app.t('documents.filter')" (click)="filterChanged()"></button>
            </ng-container>
        </sm-toolbar>
    }
    @if (!app.isMobile()) {
        <p-splitter class="height100p" styleClass="flex-item-fill flex-row-split height100p overflow-y-auto">
            <ng-template pTemplate>
                <sm-table2 #tDocuments class="width100p" [data]="table" [compact]=false [columnWidthsByContent]=true [floatingFilter]=true [useColumnMenu]=false [useTableMenu]=false [(selection)]="selection" (onRowSelect)="rowSelect($event)" (onCellClicked)="cellClicked($event)" (onCellValueChanged)="cellEdited($event)"></sm-table2>
            </ng-template>
            <ng-template pTemplate>
                <ng-container *ngTemplateOutlet="selectedDocumentTemplate"></ng-container>
            </ng-template>
        </p-splitter>
    }
    @else {
        <sm-table2 class="flex-item-fill height100p" #tDocuments [data]="table" [compact]=false [columnWidthsByContent]=true [floatingFilter]=true [useColumnMenu]=false [useTableMenu]=false [(selection)]="selection" (onRowSelect)="rowSelect($event)" (onCellClicked)="cellClicked($event)" (onCellValueChanged)="cellEdited($event)"></sm-table2>
    }
    
</div>
<p-dialog [header]="app.t('documents.uploadDocument')" [(visible)]="displayModal" [modal]="true" [style]="{width: '700px', height: '400px'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <sm-form [form]="modalForm">
    </sm-form>
        <p-footer>
            <button type="button" pButton icon="fas fa-check" (click)="insertDocument();" [label]="app.t('documents.insertDocument')"></button>
            <button type="button" pButton icon="fas fa-times" (click)="displayModal=false" [label]="app.t('general.cancel')"></button>
        </p-footer>
</p-dialog>
<p-dialog *ngIf="app.isMobile() && itemOpened" [header]="app.t('documents.details')" class="dialog-maximized" [visible]="app.isMobile() && itemOpened" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" (visibleChange)="closeItemWindow($event)">
    <ng-container *ngTemplateOutlet="selectedDocumentTemplate"></ng-container>
</p-dialog>
<ng-template #selectedDocumentTemplate>
    <p-tabView *ngIf="def != null" class="flex-item-fixed height100p width100p full-height direct-sub" [class.width30p]="!app.isMobile()">
        <p-tabPanel *ngIf="def.hasDocuments">
            <ng-template pTemplate="header">
                {{app.t('general.preview')}}
                @if (remarkObjects?.length > 1) {
                    <span class="ml-2 p-badge">{{remarkObjects.length}}</span>
                }
            </ng-template>
            @if (remarkObjects != null) {
                <p-dropdown styleClass="width100p mb-2" [options]="remarkObjects" [(ngModel)]="selectedRemarkObject"></p-dropdown>
            }
            <enaio-document-file-preview class="height100p block" [documentToken]="selectedRemarkObject?.token ?? selectedDocument?.token ?? null"></enaio-document-file-preview>
        </p-tabPanel>
        <p-tabPanel *ngIf="def != null && def.showMetaData" [header]="app.t('enaio.indexData')">
            <enaio-document-meta-data [anonymousGuid]="anonymousGuid" [document]="selectedDocument?.doc"></enaio-document-meta-data>
        </p-tabPanel>
    </p-tabView>
</ng-template>
